import gleImg from "../../assets/images/funeral-expense.jpg";
import glaImg from "../../assets/glaImg.png";
import edu from "../../assets/edu.jpg";
import goal from "../../assets/goal.png";
import ciImg from "../../assets/ciImg.jpg";
import happyfamily from "../../assets/happyfamily.png";
import groupcreditImg from "../../assets/groupcredit.png";
import annuityImg from "../../assets/annuityImg.jpg";
import motorImg from "../../assets/images/motorImg.jpg";
import healthImg from "../../assets/healthImg.jpg";
import PayDayImage from "../../assets/payday-loan.jpg";
import PayrollImage from "../../assets/payroll-loan.jpg";
import SMEImage from "../../assets/SME-loan.jpg";
import AssetImage from "../../assets/asset-financing-loan.jpg";
import POFImage from "../../assets/proof-of-fund-POF.jpg";

import { ProductCategoryEnum } from "../../shared/constants/constants";

const products = [
  {
    title: "Funeral Expense Cover",
    url: "/funeral-expense/select-customer-type",
    image: gleImg,
    description:
      "Funeral expense solution is designed to help families deal with the burden of meeting immediate funeral related expenses on the death of a family member.",
    key: "funeral",
    category: ProductCategoryEnum.INSURANCE.value,
    type: "funeralexpense",
  },
  {
    title: "Critical Illness Cover",
    image: ciImg,
    url: "customer-type",
    description:
      "Critical Illness insurance provides comprehensive coverage for against chronic illnesses such as cancer, ensuring you receive the best healthcare possible.",
    key: "medical",
    category: ProductCategoryEnum.INSURANCE.value,
    type: "criticalillness",
  },
  {
    title: "Education Insurance Cover",
    url: "education",
    image: edu,
    description:
      "An education insurance cover is a financial plan ensuring funds for a child's education, providing savings and protection against uncertainties like parent's death or disability.",
    key: "education",
    category: ProductCategoryEnum.INSURANCE.value,
    type: "educationcover",
  },
  {
    title: "Pay Day Loan",
    url: "/loan-request/pay-day-loan",
    image: PayDayImage,
    description:
      "This loan is designed to assist salaried employees in private organizations by offering quick access to funds before payday. It helps manage urgent expenses, ensuring financial stability during the gap between pay cycles. Ideal for those seeking short-term relief, it provides a convenient solution for unexpected financial needs.",
    key: "loans",
    category: ProductCategoryEnum.LOAN.value,
    type: "loanproduct",
  },

  {
    title: "SME Loans",
    url: "/loan-request/sme-loans",
    image: SMEImage,
    description:
      "Small Medium Enterprise (SME) loan is designed to enable small entrepreneurs, access fund to finance a variety of business needs – working capital, FMCGs, supply (LPO) etc., with minimum loan amount of N800,000. Loan facility is for traders and business men who have an existing business and making sales on regular basis.",
    key: "loans",
    category: ProductCategoryEnum.LOAN.value,
    type: "loanproduct",
  },
  {
    title: "Assets Finance Loan",
    url: "/loan-request/assets-finance-funds",
    image: AssetImage,
    description:
      "This product is aimed at business enterprises needing machinery and physical assets for expansion, upgrading, or diversification. It offers financial support for acquiring fixed assets, helping businesses grow and improve. Ideal for companies seeking long-term investment in their operations.",
    key: "loans",
    category: ProductCategoryEnum.LOAN.value,
    type: "loanproduct",
  },
  // {
  //   title: "Proof Of Funds (POF)",
  //   image: POFImage,
  //   url: "/loan-request/proof-of-funds",
  //   description:
  //     "This facility is designed to meet the urgent needs of individuals traveling abroad for education or invitation purposes. It offers quick financial support to cover travel expenses, ensuring a smooth and timely process for those pursuing academic opportunities or important events overseas.",
  //   key: "loans",
  //   category: ProductCategoryEnum.LOAN.value,
  //   type: "loanproduct",
  // },
  {
    title: "Payroll Loan",
    url: "/loan-request/payroll-loan",
    image: PayrollImage,
    description:
      "This loan facility is designed to address urgent needs and bridge liquidity gaps for salary earners in public establishments. Structured against monthly salaries, it serves civil servants in government entities, including Lagos State Workers, Police, Customs, Tertiary Institution Staff, FRSC.",
    key: "loans",
    category: ProductCategoryEnum.LOAN.value,
    type: "loanproduct",
  },
  {
    title: "Motor Vehicle Insurance",
    url: "/motor-vehicle/select-motor-use",
    image: motorImg,
    description:
      "Get insurance protection for your motor vehicle against accidental loss or damage, including the spare parts and standard accessories, as well as protection against legal liability to third parties.",
    key: "motor",
    category: ProductCategoryEnum.INSURANCE.value,
    type: "motorcover",
  },
  {
    title: "Health Insurance Cover",
    url: "personal-customer",
    image: healthImg,
    description:
      "Get comprehensive health insurance cover that protects you and your family against a wide range of diseases and medical conditions. Our plan includes hospitalization benefits, outpatient services, emergency care, and preventive healthcare.",
    key: "medical",
    category: ProductCategoryEnum.INSURANCE.value,
    type: "healthcover",
  },
];

export default products;
